import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "invoiceSelect", "loanSelect", "amount", "loanReferences"]
  static values = {
    defaultAmount: Number,
    defaultReferences: String,
    bookingId: Number,
    clientName: String,
    eventDate: String
  }

  connect() {
    this.updateFieldsBasedOnCategory()
  }

  categoryChanged() {
    this.updateFieldsBasedOnCategory()
  }

  invoiceChanged() {
    if (this.categoryTarget.value === "advance_on_invoice") {
      const selectedOption = this.invoiceSelectTarget.selectedOptions[0]
      if (selectedOption && selectedOption.value) {
        const amount = selectedOption.dataset.amount
        const invoiceCategory = selectedOption.dataset.category

        this.amountTarget.value = amount
        this.loanReferencesTarget.value = `${this.bookingIdValue}-${invoiceCategory}-${this.clientNameValue}-${this.eventDateValue}`
      } else {
        this.amountTarget.value = ""
      }
    }
  }

  loanChanged() {
    if (this.categoryTarget.value === "financer_early_repayment") {
      const selectedOption = this.loanSelectTarget.selectedOptions[0]
      if (selectedOption && selectedOption.value) {
        const amount = selectedOption.dataset.amount
        const financer = selectedOption.dataset.financer
        const financerExternalId = selectedOption.dataset.financerExternalId

        this.amountTarget.value = amount
        this.amountTarget.disabled = true
        this.loanReferencesTarget.value = `Kactus-Repayment ${financer} ${financerExternalId}`
      } else {
        this.amountTarget.value = ""
        this.amountTarget.disabled = false
        this.loanReferencesTarget.value = ""
      }
    }
  }

  updateFieldsBasedOnCategory() {
    const category = this.categoryTarget.value

    this.amountTarget.disabled = false

    if (category === "down_payment_financing") {
      this.amountTarget.value = this.defaultAmountValue
      this.loanReferencesTarget.value = this.defaultReferencesValue
    } else if (category === "advance_on_invoice") {
      this.invoiceChanged()
    } else if (category === "financer_early_repayment") {
      this.loanChanged()
    } else {
      this.amountTarget.value = ""
      this.loanReferencesTarget.value = ""
    }
  }
}
